export async function registryAmount(context, payload) {
    context.commit('changeAmountRequired', payload);
}